import { Badge } from "@/components/ui/badge";
import type { AdminCrewMembership } from "@produce/shared";
import InviteBadge from "./InviteBadge";
import { formatDay } from "./format";

/**
 * The productions this user was invited to as crew — the answer to "is this
 * person actually on the job they say they cannot see?".
 */
export default function CrewMembershipList({
  memberships,
}: {
  memberships: AdminCrewMembership[];
}) {
  if (memberships.length === 0) {
    return <p className="text-sm text-muted-foreground">Not invited to any production as crew.</p>;
  }

  return (
    <ul className="space-y-3">
      {memberships.map((membership) => (
        <li key={membership.briefing_id} className="rounded-md border bg-background p-3">
          <div className="flex flex-wrap items-start justify-between gap-2">
            <div>
              <p className="font-medium">{membership.festival_name || "Untitled production"}</p>
              <p className="text-sm text-muted-foreground">
                {membership.producer_name
                  ? `Producer: ${membership.producer_name}`
                  : "Producer unknown"}
                {membership.festival_date_start &&
                  ` · ${formatDay(membership.festival_date_start)}`}
              </p>
              <p className="mt-1 text-sm">
                {membership.functions.join(", ") || "No role set"} · {membership.days.length} day
                {membership.days.length === 1 ? "" : "s"}
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <InviteBadge member={membership} />
              {membership.invitation_count > 1 && (
                <span className="text-xs text-muted-foreground">
                  sent {membership.invitation_count}×
                </span>
              )}
              {membership.hidden_by_crew && <Badge variant="outline">Hidden by crew</Badge>}
              {!membership.has_account && <Badge variant="secondary">No account link</Badge>}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
